import { useState, useEffect } from 'react'
import logo from '../Assets/Imgs/Dark-Z-Logo-Square.png';
import logoNoBg from '../Assets/Imgs/logos/Zeroz-Logo-Horizontal-Black.png';
import logoFull from '../Assets/Imgs/Header-Images-Merch.jpg';
import lol from '../Assets/Imgs/MonsterEGirl.jpg';
import hero_BG from '../Assets/Imgs/zeroz_0.png';
//import story_BG from '../Assets/Imgs/BandBG00.png';
import spotify from '../Assets/Imgs/spotify.png';
import youtube from '../Assets/Imgs/youtube.png';
import insta from '../Assets/Imgs/insta.jpg';
import tiktok from '../Assets/Imgs/tiktok2.png';
import cartIcon from '../Assets/Imgs/Icons/cart3.png';
import trashIcon from '../Assets/Imgs/Icons/trash.png';
import arrowBackIcon from '../Assets/Imgs/Icons/arrowBack.png';
import shirtWhite from '../Assets/Imgs/Merch/Merch-Photo-Shirt0-White.png';
import shirtBlack from '../Assets/Imgs/Merch/Merch-Photo-Shirt0-Black.png';
import lolRecord from '../Assets/Imgs/Merch/Merch-Photo-Record-Lol.png';
import lolCD from '../Assets/Imgs/Merch/Merch-Photo-CD-Lol.png';
import stickerSmall from '../Assets/Imgs/Merch/Merch-Photo-Sticker-Small.png';
import appleMusic from '../Assets/Imgs/apple music.jpg';

import NavBar from '../Components/NavBar';
import Footer from '../Components/Footer';
import SongCard from '../Components/SongCard';
import CheckoutContainer from '../Components/CheckoutContainer'

import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase';

function Story() {

  const [cartActive, setCartActive] = useState(false);
  const [checkoutActive, setCheckoutActive] = useState(false);
  const [stockLoaded, setStockLoaded] = useState(false);
  const [cart, setCart] = useState( 
    {
      products:[],
      cost:0,
      items: {
        "CD Zeroz Lol": {
          cost: 6,
          count:0,
          name:"Lol CD",
          stock:0,
        },
        "Record Zeroz Lol": {
          cost: 25,
          count:0,
          name:"Lol Vinyl",
          stock:0,
        },
        "Black Shirts Zeroz": {
          cost:20,
          count:0,
          name:"Shirt Black",
          size:[],
          sizeStock:{large:0, medium:0, small: 0},
          stock:0,
        },
        "White Shirt Zeroz": {
          cost:20,
          count:0,
          name:"Shirt White",
          size:[],
          sizeStock:{large:0, medium:0, small: 0},
          stock:0,
        },
        "Stickers Zero Small Circle": {
          cost:1,
          count: 0,
          name:'Zeroz Sticker Small',
          stock:0,
        },
        "Zeroz Support Sied": {
          cost:3,
          count: 0,
          name:'Zeroz Support Sied',
          stock:0,
        },
        "Shipping": {
          cost:5,
          count:1,
          name: "Shipping",
          stock:1,
        }
      }
    } 
  );
  const [shirtSizeBlack, setShirtSizeBlack] = useState('Medium');
  const [shirtSizeWhite, setShirtSizeWhite] = useState('Large');

  useEffect(() => {
    let cartLoad = cart;

    const fetchItems = async () => {
      const querySnapshot = await getDocs(collection(db, "merchandise physical"));

      const fetchedItems = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));

      fetchedItems.forEach((item) =>{
        cartLoad['items'][item['id']]['stock'] = item['stock']['count'];
        if(item['multipleSizes']){
          cartLoad['items'][item['id']]['sizeStock'] = item['stock']['sizes'];
        }
      });

      setCart(cartLoad);
      setStockLoaded(true);
    };

    let ignore = false;
    fetchItems();
    return () => ignore = true;
  }, []);

  
  const addProduct = (product, cost, size) => {
    if(cart['items'][product]['stock'] < 1){
      return false
    }

    let productsChanges = cart['products'];
    let costChanges = cart['cost'] + cost;
    let itemChanges = cart['items'];
    let itemStock = [product]['stock'];
    
    productsChanges.push(product)
    itemChanges[product]['count'] += 1;
    itemChanges[product]['stock'] -= 1;

    if(itemChanges[product]['size']){
      let sizeToAdd = size;
      sizeToAdd = sizeToAdd.toLowerCase();

      if(itemChanges[product]['sizeStock'][sizeToAdd] === 0){
        return false
      }

      itemChanges[product]['sizeStock'][sizeToAdd] -= 1;
      itemChanges[product]['size'].push(size)
    }

    setCart( {products:productsChanges, cost: costChanges, items:itemChanges} );
    
    if(!cartActive){
      setCartActive(true)
    }

  }

  const removeProduct = (product, cost) => {
    if(cart['products'].length === 0 && cart['cost'] === 0){
      return false
    }

    let productsChanges = cart['products'];
    let productCheck = false;
    
    cart['products'].some( (productItem, index)=>{
      if(productItem === product){
        productsChanges.splice(index, 1);
        productCheck = true;
        return true
      }
    })

    if(!productCheck){ return false}

    let itemChanges = cart['items'];
    itemChanges[product]['count'] -= 1;
    itemChanges[product]['stock'] += 1;

    if(itemChanges[product]['size']){
      let sizeToRemove = itemChanges[product]['size'][ itemChanges[product]['size'].length - 1 ];
      
      if(!itemChanges[product]['size'][ itemChanges[product]['size'].length - 1 ]){
        return false
      }

      sizeToRemove = sizeToRemove.toLowerCase();

      itemChanges[product]['sizeStock'][sizeToRemove] += 1; 
      itemChanges[product]['size'].pop();
    }

    let costChanges = cart['cost'] - cost;
    setCart( {products:productsChanges, cost: costChanges, items: itemChanges} );
    
    if(cartActive && cart['products'].length === 0){
      setCartActive(false)
    }
    //console.log(cart['items'])
  }

  const removeFromCart = (product, cost, amount) => {
    let productsChanges = cart['products'];
    let costChanges = cart['cost'] - (cost * amount);
    let itemChanges = cart['items'];

    itemChanges[product]['count'] = 0;

    productsChanges = productsChanges.filter((productCheck) => productCheck !== product )

    setCart( {products:productsChanges, cost: costChanges, items: itemChanges} );

    if(cartActive && productsChanges.length === 0){
      setCartActive(false)
    }
  }

  const sizeChoose = (e, product) => {
    switch(product){
      case "Black Shirts Zeroz" : setShirtSizeBlack(e.target.value); break;
      case "White Shirt Zeroz" : setShirtSizeWhite(e.target.value); break;
      default : break;
    }
  }

  const cartClose = () => {
    //need to reset cart items back to OG state
    let cartLoad = cart;
    cartLoad['products'] = [];

    setCart(cartLoad);
    setCartActive(false)
  }

  return (
    <div className="App">
      {!checkoutActive &&
        <div className="App">
          <NavBar />
          <img src={logoFull} className="header-img" alt="header" />

          <div className="page-section-merch">
            <p className="pageNotification">We are currently only shipping within the US, we sincerely apologize for the inconvenience</p>
            <h2 className="black">Shirts</h2>
            
            <div className="row space-evenly full" style={{paddingBottom:'2rem'}}>
              
              <div className="card-holder">
                <div className='card card-merch'>
                  <img src={shirtBlack} />
                </div>
                <p className="product-title">Black Zeroz Shirt</p>
                <p className="product-description">A black shirt with the Zeroz logo.</p>
                <p className="product-cost">Quantity: {cart['items']['Black Shirts Zeroz']['stock']} </p>
                <select name="shirt-black" id='shirt-black' className="product-size" onChange={(e)=>{sizeChoose(e, 'Black Shirts Zeroz')}} >
                  <option value="">Choose a Size</option>
                  <option value="Large" className="product-size" >Large in stock: {cart['items']['Black Shirts Zeroz']['sizeStock']['large']}</option>
                  <option value="Medium" className="product-size" >Medium in stock: {cart['items']['Black Shirts Zeroz']['sizeStock']['medium']}</option>
                  <option value="Small" className="product-size" >Small in stock: {cart['items']['Black Shirts Zeroz']['sizeStock']['small']}</option>
                </select>
                <p className="product-cost">Cost: $20</p>
                <div className="row space-evenly productButtons">
                  <button className="" onClick={()=>{addProduct('Black Shirts Zeroz', 20, shirtSizeBlack)}}>Add +</button>
                  <button className="" onClick={()=>{removeProduct('Black Shirts Zeroz', 20, shirtSizeBlack)}}>Remove -</button>
                </div>
              </div>

              <div className="card-holder">
                <div className='card card-merch'>
                  <img src={shirtWhite} />
                </div>
                <p className="product-title">White Zeroz Shirt</p>
                <p className="product-description">A white shirt with the Zeroz logo.</p>
                <p className="product-cost">Quantity: {cart['items']["White Shirt Zeroz"]['stock']} </p>
                <select name="shirt-white" id='shirt-white' className="product-size" onChange={(e)=>{sizeChoose(e, 'White Shirt Zeroz')}} >
                  <option value="">Choose a Size</option>
                  <option value="Large" className="product-size" >Large in stock: {cart['items']['White Shirt Zeroz']['sizeStock']['large']}</option>
                  <option value="Small" className="product-size" >Small in stock: {cart['items']['White Shirt Zeroz']['sizeStock']['small']}</option>
                </select>
                <p className="product-cost">Cost: $20</p>
                <div className="row space-evenly productButtons">
                  <button className="" onClick={()=>{addProduct('White Shirt Zeroz', 20, shirtSizeWhite )}}>Add +</button>
                  <button className="" onClick={()=>{removeProduct('White Shirt Zeroz', 20, shirtSizeWhite)}}>Remove -</button>
                </div>
              </div>

            </div>
          
          </div>

          <div className="page-section-merch">

            <h2 className="black">Music</h2>
            
            <div className="row space-evenly full" style={{paddingBottom:'2rem'}}>
              
              <div className="card-holder">
                <div className='card card-merch'>
                  <img src={lolCD} />
                </div>
                <p className="product-title">Lol CD</p>
                <p className="product-description">The Zeroz album Lol on CD</p>
                <p className="product-cost">Cost: $6</p>
                <p className="product-cost">Quantity: {cart['items']["CD Zeroz Lol"]['stock']} </p>
                <div className="row space-evenly productButtons">
                  <button className="" onClick={()=>{addProduct('CD Zeroz Lol', 6)}}>Add +</button>
                  <button className="" onClick={()=>{removeProduct('CD Zeroz Lol', 6)}}>Remove -</button>
                </div>
              </div>

              <div className="card-holder">
                <div className='card card-merch'>
                  <img src={lolRecord} />
                </div>
                <p className="product-title">Lol Vinyl</p>
                <p className="product-description">The Zeroz album Lol on vinyl</p>
                <p className="product-cost">Cost: $25</p>
                <p className="product-cost">Quantity: {cart['items']["Record Zeroz Lol"]['stock']} </p>
                <div className="row space-evenly productButtons">
                  <button className="" onClick={()=>{addProduct('Record Zeroz Lol', 25)}}>Add +</button>
                  <button className="" onClick={()=>{removeProduct('Record Zeroz Lol', 25)}}>Remove -</button>
                </div>
              </div>

            </div>
          
          </div>

          <div className="page-section-merch">

            <h2 className="black">Lil Things</h2>
            
            <div className="row space-evenly full" style={{paddingBottom:'2rem'}}>
              
              <div className="card-holder">
                <div className='card card-merch'>
                  <img src={stickerSmall} />
                </div>
                <p className="product-title">Zeroz Circle Sticker</p>
                <p className="product-description">Zeroz 1.5 inch sticker</p>
                <p className="product-cost">Quantity: {cart['items']["Stickers Zero Small Circle"]['stock']} </p>
                <p className="product-cost">Cost: $1</p>
                <div className="row space-evenly productButtons">
                  <button className="" onClick={()=>{addProduct('Stickers Zero Small Circle', 1)}}>Add +</button>
                  <button className="" onClick={()=>{removeProduct('Stickers Zero Small Circle', 1)}}>Remove -</button>
                </div>
              </div>

              {/*
              <div className="card-holder">
                <div className='card card-merch'>
                  <img src={stickerSmall} />
                </div>
                <p className="product-title">Zeroz Support Sied</p>
                <p className="product-description">Plant a digital seed for Zeroz </p>
                <p className="product-cost">Quantity: {cart['items']["Stickers Zero Small Circle"]['stock']} </p>
                <p className="product-cost">Cost: $3</p>
                <div className="row space-evenly productButtons">
                  <button className="" onClick={()=>{addProduct('Zeroz Support Sied', 1)}}>Add +</button>
                  <button className="" onClick={()=>{removeProduct('Zeroz Support Sied', 1)}}>Remove -</button>
                </div>
              </div>
              */}

            </div>
          
          </div>

          {cartActive  &&
            <div className="cartSmallHolder">
              <div className="cartSmall">
                <img src={cartIcon} alt="cart" className="cartIcon" />
                {/*<p className="cartClose" onClick={()=>{cartClose()}}>X</p> */}
                
                {Object.entries(cart['items']).map((item, index) =>{
                  if(item[1]['count'] === 0){return false}
                  if(item[1]['name'] === 'Shipping'){return false}

                  if(item[1]['size']){
                    let small = [];
                    let medium = [];
                    let large = [];

                    item[1]['size'].forEach((itemSize) => {
                      if(itemSize === 'Small'){small.push(itemSize)};
                      if(itemSize === 'Medium'){medium.push(itemSize)};
                      if(itemSize === 'Large'){large.push(itemSize)};
                    })

                    return(
                      <>
                      {small.length > 0 &&  <div className="row centerAlign spaceBetween" key={index + "small"}>
                          <p>{item[1]['name']} {small[0]} x {small.length}</p>
                          <img src={trashIcon} alt="trash" className="icon iconTrash" onClick={()=>{ removeFromCart(item[0], item[1]['cost'], item[1]['count']) }} />
                        </div>
                      }
                      {medium.length > 0 &&  <div className="row centerAlign spaceBetween" key={index + "medium"}>
                          <p>{item[1]['name']} {medium[0]} x {medium.length}</p>
                          <img src={trashIcon} alt="trash" className="icon iconTrash" onClick={()=>{ removeFromCart(item[0], item[1]['cost'], item[1]['count']) }} />
                        </div>
                      }
                      {large.length > 0 &&  <div className="row centerAlign spaceBetween" key={index + "large"}>
                          <p>{item[1]['name']} {large[0]} x {large.length}</p>
                          <img src={trashIcon} alt="trash" className="icon iconTrash" onClick={()=>{ removeFromCart(item[0], item[1]['cost'], item[1]['count']) }} />
                        </div>
                      }
                      </>
                    )
                  }

                  else{
                    return(
                      <div className="row centerAlign spaceBetween" key={index}>
                        <p>{item[1]['name']} x {item[1]['count']}</p>
                        <img src={trashIcon} alt="trash" className="icon iconTrash" onClick={()=>{ removeFromCart(item[0], item[1]['cost'], item[1]['count']) }} />
                      </div>
                    )
                  }
                  
                })}
                <p>{cart['products'].length} {cart['products'].length > 1 ? 'items' : 'item'}</p>
                <hr />
                <p>Total = ${cart['cost']}</p>
              </div>

              <div className="cartCheckout" onClick={()=> setCheckoutActive(true)}>
                <p>Checkout</p>
              </div>
            </div>
          }

          <Footer />
        </div>
      }
      
      {checkoutActive &&
        <div className="App-header story-header">
            <div className="cartMedium">
              <p className="pageNotification pillForm">We are currently only shipping within the US, we sincerely apologize for the inconvenience</p>
              <img src={cartIcon} alt="cart" className="cartIcon" />
              {Object.entries(cart['items']).map((item, index) =>{
                if(item[1]['count'] === 0){return false}

                if(item[1]['size']){
                  let small = [];
                  let medium = [];
                  let large = [];

                  item[1]['size'].forEach((itemSize) => {
                    console.log(itemSize)
                    if(itemSize === 'Small'){small.push(itemSize)};
                    if(itemSize === 'Medium'){medium.push(itemSize)};
                    if(itemSize === 'Large'){large.push(itemSize)};
                  })
                  
                  return(
                    <>
                    {small.length > 0 &&  <div className="row centerAlign spaceBetween" key={index + "small"}>
                        <p>{item[1]['name']} {small[0]} x {small.length}</p>
                        <img src={trashIcon} alt="trash" className="icon iconTrash" onClick={()=>{ removeFromCart(item[0], item[1]['cost'], item[1]['count']) }} />
                      </div>
                    }
                    {medium.length > 0 &&  <div className="row centerAlign spaceBetween" key={index + "medium"}>
                        <p>{item[1]['name']} {medium[0]} x {medium.length}</p>
                        <img src={trashIcon} alt="trash" className="icon iconTrash" onClick={()=>{ removeFromCart(item[0], item[1]['cost'], item[1]['count']) }} />
                      </div>
                    }
                    {large.length > 0 &&  <div className="row centerAlign spaceBetween" key={index + "large"}>
                        <p>{item[1]['name']} {large[0]} x {large.length}</p>
                        <img src={trashIcon} alt="trash" className="icon iconTrash" onClick={()=>{ removeFromCart(item[0], item[1]['cost'], item[1]['count']) }} />
                      </div>
                    }
                    </>
                  )
                }

                else{
                  return(
                    <div className="row centerAlign spaceBetween" key={index}>
                      <p>{item[1]['name']} ${item[1]['cost']} {item[1]['name'] !== 'Shipping' && "x " + item[1]['count']}</p>
                      <img src={trashIcon} alt="trash" className="icon iconTrash" onClick={()=>{ removeFromCart(item[0], item[1]['cost'], item[1]['count']) }} />
                    </div>
                  )
                }
                
              })}
              <p>{cart['products'].length} {cart['products'].length > 1 ? 'items' : 'item'}</p>
              <hr />
              <p>Total = ${cart['cost'] + 5}</p>
            </div>

            <div className="top0Left column" >
              <h1 className="black" style={{margin:'12px 0'}}>Zeroz Checkout</h1>
              <img className="icon" style={{margin:'0'}} src={arrowBackIcon} onClick={()=> setCheckoutActive(false)} />
            </div>

          <CheckoutContainer paymentDue={cart['cost'] + 5} checkoutItems={cart['items']} />
        
        </div>
      }

    </div>
  );
}

export default Story;
